module.exports = __webpack_public_path__ + "static/media/header_home.ff17d030.jpg";